import { useState, useEffect } from "react";
import usePersistedState from "../utils/usePersistedState";
import { setApisURLs, setApiConfig } from "../submodule/src/utils/api";
import { getUserTenants, isTenantValidForEnvironment } from "../submodule/src/utils/roles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Menu, MenuItem } from "@mui/material";

function getEnvironmentColor(tenant) {
  const t = (tenant || "").toUpperCase();
  if (/(^|[-_])PROD$/i.test(t)) return "#ef4444";
  if (/(^|[-_])(TEST|STG|QA)$/i.test(t)) return "#eab308";
  return "#10b981";
}

const RoleSelector = () => {
  const [roles] = usePersistedState("userTenants", getUserTenants());
  const filteredRoles = roles
    .filter((r) => /(dev|test|prod)$/.test(r))
    .filter(isTenantValidForEnvironment);
  const [role, setRole] = usePersistedState("userTenant", filteredRoles[0]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleRoleClick = (event) => setAnchorEl(event.currentTarget);
  const handleRoleClose = () => setAnchorEl(null);

  const handleRoleChange = async (newRole) => {
    handleRoleClose();
    if (role !== newRole) {
      setRole(newRole);
      setApisURLs(newRole);
      await setApiConfig(newRole);
      window.location.reload();
    }
  };

  useEffect(() => {
    if (filteredRoles.length > 0 && !filteredRoles.includes(role)) {
      handleRoleChange(filteredRoles[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (filteredRoles.length === 0) return null;

  return (
    <div>
      <Button
        aria-controls="role-menu"
        aria-haspopup="true"
        onClick={handleRoleClick}
        variant="text"
        color="inherit"
        className="flex items-center"
        sx={{
          textTransform: "none",
          fontSize: "0.9rem",
          padding: "6px 12px",
          minWidth: "100px",
        }}
        endIcon={<ExpandMoreIcon color="action" sx={{ fontSize: "1.5rem" }} />}
      >
        <span
          style={{
            display: "inline-block",
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: getEnvironmentColor(role),
            marginRight: 8,
            flexShrink: 0,
          }}
        />
        {role?.toUpperCase() || "TENANT"}
      </Button>
      <Menu
        id="role-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleRoleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {filteredRoles.map((tenant) => (
          <MenuItem
            key={tenant}
            onClick={() => handleRoleChange(tenant)}
            sx={{ fontSize: "0.875rem", color: "text.secondary" }}
          >
            <span
              style={{
                display: "inline-block",
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: getEnvironmentColor(tenant),
                marginRight: 10,
                flexShrink: 0,
              }}
            />
            {tenant?.toUpperCase()}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default RoleSelector;
